function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBitbucket(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "800px",
    height: "800px",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    cx: 512,
    cy: 512,
    r: 512,
    style: {
      fill: "#0052cc"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M272.6 281.9c-9-.1-16.5 7.1-16.6 16.2 0 1 0 1.9.2 2.9l69.6 422.6c1.8 10.6 11 18.5 21.8 18.6h334c8.1.1 15.1-5.8 16.4-13.8L767.8 301c1.5-8.9-4.6-17.3-13.5-18.8-1-.2-1.9-.2-2.8-.2l-478.9-.1zm293.2 305.4H459.1l-28.8-150.7h161.3l-25.8 150.7z",
    style: {
      fill: "#fff"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBitbucket);
export default __webpack_public_path__ + "static/media/bitbucket.669aa491a0a62aabd1c0a14f082096d9.svg";
export { ForwardRef as ReactComponent };